import React, { Component } from 'react';
import { Table, Icon, InputNumber, Switch } from 'antd';
import PropTypes from 'prop-types';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, priceFenToYuanCell } from '@/components/TableCell';
import { regFenToYuan, } from '@/util/money';
import { FloatConversion } from '@/util/conversion';

export default class TableContent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.floatConversion = new FloatConversion();
    }
    _columns = () => ([
        {
            title: '投诉原因',
            dataIndex: 'reason',
            key: 'reason',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '罚金(元)',
            dataIndex: 'penalty',
            key: 'penalty',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, item) => {
                return <span>{`${-regFenToYuan(text)}`}</span>;
            }
        },
        {
            title: '拉黑',
            dataIndex: 'shieldNum',
            key: 'shieldNum',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, item) => {
                return <span>{`${-text}`}</span>;
            }
        },
        {
            title: '扣等级分值',
            dataIndex: 'lvNum',
            key: 'lvNum',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, item) => {
                return <span>{`${-text}`}</span>;
            }
        },
        // {
        //     title: '服务分值',
        //     dataIndex: 'serviceNumSubtract',
        //     key: 'serviceNumSubtract',
        //     width: '10%',
        //     align: 'center',
        //     onCell: tooltipStyle,
        //     render: tooltip
        // },
        {
            title: '排序',
            dataIndex: 'sortNo',
            key: 'sortNo',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            // render: tooltip
            render: (text, item) => {
                if (item.id == 1) {
                    return <span>-</span>;
                } else {
                    return <span>{text}</span>;
                }
            }
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: '10%',
            align: 'center',
            render: (text, item) => this._switchCell(text, item)
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '10%',
            render: (id, record) => this._tableAction(id, record)
        }
    ]);

    _tableAction = (id, record) => {
        const { tableAction } = this.props;
        return (< div className={styles.action} >
            {record.isInit != '1' && <div className={styles.item} onClick={() => tableAction(id, 'editor', record)}>编辑</div>}
            {/* <div className={styles.item} onClick={() => tableAction(id, 'delete')}>删除</div> */}
        </div >);
    };

    // 开关
    _switchCell = (sw, item) => {
        let checked = true;
        if (sw == '0') {
            checked = false;
        }
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                <Switch
                    checkedChildren="开"
                    unCheckedChildren="关"
                    checked={checked}
                    disabled={item.id == 1}
                    onChange={(value) => {
                        this.props.tableAction(item, 'switch', value);
                    }}
                />
            </div>
        );
    };

    // 表格项内容为可编辑
    sortCell = (value, item) => {
        const label = React.createRef();
        const box = React.createRef();
        const input = React.createRef();

        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                <div className={styles.sort_box}>
                    <div className={styles.label} ref={label}>{value}</div>
                    <div className={styles.input} ref={box}>
                        <InputNumber
                            key={item.id}
                            style={{ width: '70px' }}
                            ref={input}
                            defaultValue={value}
                            min={1}
                            max={99}
                            precision={0}
                            placeholder='请输入'
                            onBlur={(e) => {
                                box.current.style.display = 'none';
                                label.current.style.display = 'block';
                                if (e.target.value && (value != e.target.value)) {
                                    this.props.tableAction(item, 'sort', e.target.value);
                                }
                            }}
                        />
                    </div>
                    <div
                        className={styles.icon}
                        onClick={() => {
                            label.current.style.display = 'none';
                            box.current.style.display = 'block';
                            input.current.focus();
                        }}
                    >
                        <Icon type="edit" style={{ fontSize: '18px' }} />
                    </div>
                </div>
            </div>
        );
    };


    // 解析表格数据，使符合columns格式要求
    _takeDataSource = (data) => {
        return data;
    }

    //渲染组件
    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this._columns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableContent.propTypes = {
    renderData: PropTypes.object, // 表格数据源
    paginationChange: PropTypes.func, // 分页
    tableAction: PropTypes.func, // 对表格的操作
};